document.querySelectorAll('.menu-toggle').forEach((button) => {
  button.addEventListener('click', () => {
    const menu = document.getElementById(button.getAttribute('aria-controls'));
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    menu.hidden = open;
  });
});

document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
  const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
  const dots = [...carousel.querySelectorAll('[data-hero-dot]')];
  let current = 0;
  let timer;
  const show = (next) => {
    current = (next + slides.length) % slides.length;
    slides.forEach((slide, index) => {
      const active = index === current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      dots[index].classList.toggle('is-active', active);
      dots[index].setAttribute('aria-current', String(active));
    });
  };
  const start = () => {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      clearInterval(timer);
      timer = setInterval(() => show(current + 1), 7000);
    }
  };
  carousel.querySelector('[data-hero-prev]').addEventListener('click', () => { show(current - 1); start(); });
  carousel.querySelector('[data-hero-next]').addEventListener('click', () => { show(current + 1); start(); });
  dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
  carousel.addEventListener('mouseenter', () => clearInterval(timer));
  carousel.addEventListener('mouseleave', start);
  carousel.addEventListener('focusin', () => clearInterval(timer));
  carousel.addEventListener('focusout', (event) => { if (!carousel.contains(event.relatedTarget)) start(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) clearInterval(timer); else start(); });
  start();
});
